<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { type IconName, ICONS } from './icons.ts'

export interface Props {
  name: IconName
}

defineProps<Props>()
</script>

<template>
  <FontAwesomeIcon
    aria-hidden="true"
    :icon="ICONS[name]"
  />
</template>
